import Flex from '@Components/Bases/Flex';
import { IntroductionButton, RemarkButton } from '@Components/IconButton';
import Introduction from '@Components/Introduction';
import Remark from '@Components/Remark';
import { useDisclosure } from '@hooks/useDisclosure';
import { Typography } from '@mui/material';
import { ProductInformationFormValues } from '../../NatureOfBusinessFormProvider/types';
import { useNatureOfBusinessForm } from '../../NatureOfBusinessFormProvider';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useWatch } from 'react-hook-form';

const BusinessGroupIntroduction = () => {
  const { getValues } = useNatureOfBusinessForm();
  const {
    businessGroupIntroduction: introduction,
    businessGroupRemark: remark,
  } = getValues('productInformation') ?? ({} as ProductInformationFormValues);
  const { isCompletedTh, isCompletedEn } =
    useWatch({
      name: 'productInformation.completedSection',
    }) ?? ({} as CompleteSectionFormValues);
  const [
    openedIntroduction,
    { open: openIntroduction, close: closeIntroduction },
  ] = useDisclosure(!!introduction);
  const [openedRemark, { open: openRemark, close: closeRemark }] =
    useDisclosure(!!remark);

  return (
    <Flex gap={1} flexDirection={'column'}>
      <Flex gap={1} alignItems={'center'}>
        <Typography fontWeight={800}>ลักษณะผลิตภัณฑ์หรือบริการ</Typography>
        <Flex gap={0.5} alignItems={'center'}>
          <IntroductionButton
            onClick={openIntroduction}
            disabled={isCompletedTh && isCompletedEn}
          />
          <RemarkButton
            onClick={openRemark}
            disabled={isCompletedTh && isCompletedEn}
          />
        </Flex>
      </Flex>
      {openedIntroduction && (
        <Introduction
          onDelete={closeIntroduction}
          topic="ลักษณะผลิตภัณฑ์หรือบริการ"
          setOpen={closeIntroduction}
          fieldPath="productInformation.businessGroupIntroduction"
          isCompletedTh={isCompletedTh}
          isCompletedEn={isCompletedEn}
        />
      )}
      {openedRemark && (
        <Remark
          onDelete={closeRemark}
          topic="ลักษณะผลิตภัณฑ์หรือบริการ"
          setOpen={closeRemark}
          fieldPath="productInformation.businessGroupRemark"
          isCompletedTh={isCompletedTh}
          isCompletedEn={isCompletedEn}
        />
      )}
    </Flex>
  );
};

export default BusinessGroupIntroduction;
